import { apiClient } from './authService';

/* =======================
   Types
======================= */

export interface ExpenseItemInput {
  description?: string;
  amount: number;
}

export interface CreateExpensePayload {
  amount: number;
  currency: string;
  title: string;
  notes?: string;
  accountId: number;
  paid?: boolean;
  // Create the expense already paid (skips the separate pay step)
  autoPay?: boolean;
  description?: string;
  items?: ExpenseItemInput[];

  metadata?: {
    unitId?: string;
    businessId?: string;
    type?: string;
    supplierName?: string | null;
    supplierPhone?: string | null;
    supplierOrgUserId?: string | number | null;
    invoiceNumber?: string | null;
    invoice_nb?: string | null;
    lines?: any[];
    discountPercent?: number;
    vatPercent?: number;
  };
}

export interface ListExpensesParams {
  from?: string; // ISO date
  to?: string;   // ISO date
  paid?: boolean;

  // metadata filters
  unitId?: string;
  businessId?: string;

  // pagination/search (optional; backend may ignore if unsupported)
  page?: number;
  size?: number;
  search?: string;
  /** Ask for the amount total over every matching expense. */
  summary?: boolean;
}

/* =======================
   API Calls
======================= */

// CREATE
export async function createExpense(payload: CreateExpensePayload) {
  const res = await apiClient.post('/expenses', payload);
  return res.data;
}

// LIST (by metadata)
export async function listExpenses(params?: ListExpensesParams) {
  const query = new URLSearchParams({
    ...(params?.from && { from: params.from }),
    ...(params?.to && { to: params.to }),
    ...(params?.paid !== undefined && { paid: String(params.paid) }),
    ...(params?.unitId && { unitId: params.unitId }),
    ...(params?.businessId && { businessId: params.businessId }),
    ...(params?.page !== undefined && { page: String(params.page) }),
    ...(params?.size !== undefined && { size: String(params.size) }),
    ...(params?.search && { search: String(params.search) }),
    ...(params?.summary && { summary: "true" }),
  }).toString();

  const res = await apiClient.get(
    `/expenses${query ? `?${query}` : ''}`,
  );
  return res.data;
}

// GET ONE
export async function getExpenseById(id: number) {
  const res = await apiClient.get(`/expenses/${id}`);
  return res.data;
}

// APPROVE
export async function approveExpense(id: number) {
  const res = await apiClient.post(`/expenses/${id}/approve`);
  return res.data;
}

// PAY
export async function payExpense(id: number) {
  const res = await apiClient.post(`/expenses/${id}/pay`);
  return res.data;
}


export async function updateExpense(id: number, payload: CreateExpensePayload) {
  const res = await apiClient.put(`/expenses/${id}`, payload);
  return res.data;
}

export async function deleteExpense(id: number) {
  const res = await apiClient.delete(`/expenses/${id}`);
  return res.data;
}
